export default __webpack_public_path__ + "static/media/04_photo.bf8d025d.jpg";